import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

export interface BulkProjectUpdateItem {
  id: string | number;
  [key: string]: any;
}

export interface CreatedBulkActionResponse {
  project_bulk_action: {
    id: string;
    action_type: string;
    related_to_type: string;
    channel: string;
  };
}

@Injectable({ providedIn: 'root' })
export class BulkEditService {
  private httpClient = inject(HttpClient);

  createBulkUpdateAction(projects: BulkProjectUpdateItem[]): Observable<CreatedBulkActionResponse> {
    const url = `project_bulk_actions`;
    const body = {
      action_type: 'update',
      projects,
    };

    return this.httpClient.post<CreatedBulkActionResponse>(url, body).pipe(map((response) => response));
  }
}


